import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const AIProcessingStatus = ({ 
  isProcessing = false, 
  progress = 0, 
  stage = 'Memproses data...', 
  showIndicator = false,
  onComplete = () => {} 
}) => {
  const [currentProgress, setCurrentProgress] = useState(0);

  useEffect(() => {
    if (isProcessing) {
      setCurrentProgress(progress);
    }
  }, [progress, isProcessing]);

  useEffect(() => {
    if (currentProgress >= 100 && isProcessing) {
      const timer = setTimeout(() => {
        onComplete();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [currentProgress, isProcessing, onComplete]);

  if (!isProcessing && !showIndicator) return null;

  if (showIndicator && !isProcessing) {
    return (
      <div className="ai-status-indicator">
        <div className="ai-status-indicator-pulse" />
        <span className="ai-status-indicator-text">AI Siap</span>
      </div>
    );
  }

  return (
    <div className="ai-status-overlay">
      <div className="ai-status-content">
        <div className="ai-status-icon">
          <Icon name="Brain" size={32} color="var(--color-primary)" />
        </div>
        
        <h3 className="ai-status-title">Analisis AI Sedang Berjalan</h3>
        <p className="ai-status-description">{stage}</p>
        
        <div className="ai-status-progress">
          <div 
            className="ai-status-progress-bar" 
            style={{ width: `${currentProgress}%` }}
          />
        </div>
        
        <div className="ai-status-percentage">
          {Math.round(currentProgress)}%
        </div>
        
        <div className="mt-6 text-center">
          <p className="text-sm text-muted-foreground">
            Mohon tunggu, sistem sedang menganalisis data Anda...
          </p>
        </div>
      </div>
    </div>
  );
};

export default AIProcessingStatus;